module.exports = __webpack_public_path__ + "img/c22.7fb26869.png";